/**
 * @flow
 */
/* eslint-disable no-confusing-arrow */
import React from 'react'
import ContactPersonIcon from '../../../../Icons/ContactPersonIcon'
import SmartPhone from '../../../../Icons/SmartPhone'
import ContactMembers from '../../../../Icons/ContactMembers'
import Calendar from '../../../../Icons/Calendar'
import {
  BookingDetailsContainer,
  BookingDetailsInnerContainer,
  BookingDetailsText,
  ContactNameContainer,
  ContactText,
  MobileNumberContainer,
  MobileText,
  ContactMembersContainer,
  MembersCountText,
  CalendarText,
  CalendarContainer,
  ContinueButtonContainer,
  ContinueButtonText,
  DetailsContainer,
  Container,
  PackageText,
  BookingWrapper
} from './styledComponents'

class BookingDetails extends React.Component<Props> {
  getNoOfPeopleLabel = noOfPeople => {
    const castedNoOfPeople = Number(noOfPeople)
    return castedNoOfPeople === 1
      ? `${noOfPeople} member`
      : `${noOfPeople} members`
  }

  renderPackageContent = () => {
    const { packageBooked } = this.props
    if (packageBooked) {
      return (
        <Container>
          <PackageText>Package: {packageBooked}</PackageText>
        </Container>
      )
    }
    return null
  }

  render() {
    const {
      bookingDetailsHeading,
      personName,
      mobileNumber,
      noOfPeople,
      dateOfBooking,
      closeLightBox,
      continueButtonText
    } = this.props

    return (
      <BookingDetailsContainer>
        <BookingDetailsInnerContainer>
          <BookingWrapper>
            <BookingDetailsText>{bookingDetailsHeading}</BookingDetailsText>
            <DetailsContainer>
              <ContactNameContainer id="name">
                <ContactPersonIcon />
                <ContactText>{personName}</ContactText>
              </ContactNameContainer>
              <MobileNumberContainer id="phone-number">
                <SmartPhone />
                <MobileText>{mobileNumber}</MobileText>
              </MobileNumberContainer>
              <ContactMembersContainer id="no-of-people">
                <ContactMembers />
                <MembersCountText>
                  {`${this.getNoOfPeopleLabel(noOfPeople)}`}
                </MembersCountText>
              </ContactMembersContainer>
              <CalendarContainer id="date-of-slot">
                <Calendar />
                <CalendarText>{dateOfBooking}</CalendarText>
              </CalendarContainer>
              {this.renderPackageContent()}
            </DetailsContainer>
          </BookingWrapper>
          <ContinueButtonContainer
            onClick={closeLightBox}
            id="continue-to-website-button"
          >
            <ContinueButtonText>{continueButtonText}</ContinueButtonText>
          </ContinueButtonContainer>
        </BookingDetailsInnerContainer>
      </BookingDetailsContainer>
    )
  }
}

export default BookingDetails



// WEBPACK FOOTER //
// ./src/components/IbcArcade/BookingResponseMessage/BookingDetails/index.js